import { organisationConstants } from '../../_constants/organisation.constants';
import { organisationService } from '../../_services/organisation.service';

export const GroupReportAction = {
    groupReportList,
    groupReportAssesorList,
    groupReportInstrumentList,
    groupReportPDF
}

function groupReportInstrumentList(callback) {
    return dispatch => {
        dispatch(request());
        organisationService.groupReportInstrumentList()
            .then(
                instrumentList => {
                    dispatch(success({ instrumentList }));
                    if (callback) {
                        callback(instrumentList)
                    }
                },
                error => {
                    dispatch(failure(error));
                    if (callback) {
                        callback(error, 'ERROR');
                    }
                }
            );
    };

    function request() { return { type: organisationConstants.REQUEST_GROUP_REPORT_LIST_INSTRUMENT } }
    function success(instrumentList) { return { type: organisationConstants.RECIEVE_GROUP_REPORT_LIST_INSTRUMENT, instrumentList } }
    function failure(error) { return { type: organisationConstants.ERROR_GROUP_REPORT_LIST_INSTRUMENT, error } }
}

function groupReportAssesorList(data, callback) {

    return dispatch => {
        dispatch(request());
        organisationService.groupReportAssesorList(data)
            .then(
                assessorList => {
                    dispatch(success({ assessorList }));
                    if (callback) {
                        callback(assessorList)
                    }
                },
                error => {
                    dispatch(failure(error));
                    if (callback) {
                        callback(error, 'ERROR');
                    }
                }
            );
    };

    function request() { return { type: organisationConstants.REQUEST_GROUP_REPORT_LIST_ASSESSOR } }
    function success(assessorList) { return { type: organisationConstants.RECIEVE_GROUP_REPORT_LIST_ASSESSOR, assessorList } }
    function failure(error) { return { type: organisationConstants.ERROR_GROUP_REPORT_LIST_ASSESSOR, error } }
}

function groupReportPDF(data, callback) {
    return dispatch => {
        dispatch(request());
        organisationService.groupReportPDFService(data)
            .then(
                pdfdata => {
                    dispatch(success({ pdfdata, data }));
                    callback(pdfdata)
                },
                error => {
                    dispatch(failure(error));
                    callback(error, 'ERROR');
                }
            );
    };

    function request() { return { type: organisationConstants.REQUEST_GROUP_REPORT_LIST_PDF } }
    function success(pdfdata) { return { type: organisationConstants.RECIEVE_GROUP_REPORT_LIST_PDF, pdfdata } }
    function failure(error) { return { type: organisationConstants.ERROR_GROUP_REPORT_LIST_PDF, error } }
}

function groupReportList(data, callback) {
    return dispatch => {
        dispatch(request());
        organisationService.groupReportListService(data)
            .then(
                org_assessment_list => {
                    dispatch(success(org_assessment_list));
                    if (callback) {
                        callback(org_assessment_list)
                    }
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: organisationConstants.REQUEST_GROUP_REPORT_LIST } }
    function success(org_assessment_list) { return { type: organisationConstants.RECIEVE_GROUP_REPORT_LIST, org_assessment_list } }
    function failure(error) { return { type: organisationConstants.ERROR_GROUP_REPORT_LIST, error } }
}


// WEBPACK FOOTER //
// ./src/_actions/organisations/groupReport.action.js